module.exports = __webpack_public_path__ + "img/5.70d8435f.webp";